import { Flex } from "@chakra-ui/react";

import { useSlugParam } from "@/common/hooks/useParam";
import { FeatureAdoption } from "@/feature/components/FeatureAdoption";
import { FeatureEvents } from "@/feature/components/FeatureEvents";
import { FeatureFeedback } from "@/feature/components/FeatureFeedback";
import FeatureSideBarWrapper from "@/feature/components/FeatureSidebarWrapper";
import { SetupInstructions } from "@/feature/components/SetupInstructions";
import { useFlag } from "@reflag/react-sdk";

export const MONITOR_CARD_HEIGHT = 60;

export default function FeatureMonitor() {
  const { featureId } = useSlugParam("feature");
  const { isEnabled: showMonitorEvents } = useFlag("monitor-events");

  return (
    <FeatureSideBarWrapper>
      <Flex direction="column" flexGrow={1} gap={8} h="full" px={6} py={4}>
        <SetupInstructions featureId={featureId} usecase="monitor" />
        <FeatureAdoption />
        <FeatureFeedback />
        {showMonitorEvents && <FeatureEvents />}
      </Flex>
    </FeatureSideBarWrapper>
  );
}
